import { render, staticRenderFns } from "./PortalRfxResponseCombined.vue?vue&type=template&id=378d9a24"
import script from "./PortalRfxResponseCombined.vue?vue&type=script&lang=js"
export * from "./PortalRfxResponseCombined.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports